import { WarningCircle } from '@phosphor-icons/react';

import { cn } from '../../utils/cn';

/**
 * `.pen` `ds/message--danger` (uKwUb) na instância `callout-erro` dos frames
 * `Onboarding · … · erro`: `rounded-$radius-ds-xl`, `padding $space-4`,
 * ícone `warning-circle` 20px, título `$type-body` 600, descrição `$type-body-sm`.
 */
export function WizardErrorCallout({ children, description, className }) {
  if (!children) return null;

  return (
    <div
      role="alert"
      data-ds-id="ds/message--danger"
      className={cn(
        'flex items-start gap-space-3 rounded-ds-xl border border-danger-500 bg-danger-tint p-space-4',
        className,
      )}
    >
      <WarningCircle className="size-5 shrink-0 text-danger-fg" weight="regular" aria-hidden />
      <div className="flex min-w-0 flex-1 flex-col gap-space-1">
        <p className="m-0 text-type-body font-semibold leading-[1.45] text-danger-fg">{children}</p>
        {description ? (
          <p className="m-0 text-type-body-sm leading-[1.4] text-muted-foreground">{description}</p>
        ) : null}
      </div>
    </div>
  );
}

export default WizardErrorCallout;
